export default __webpack_public_path__ + "static/media/alert-icon-6.db191258.svg";